import { useMutation } from "react-query"

import reservationsService from "api/reservationsService"
import { IUpdateReservationInfo } from "types/reservation"

const useUpdateReservationInfoMutation = () => {
  return useMutation(async (params: IUpdateReservationInfo) => {
    try {
      const res = await reservationsService.updateReservationInfo(params)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useUpdateReservationInfoMutation
